import { createSlice } from '@reduxjs/toolkit';
import { GlobalState } from 'types';

const initialState: GlobalState = {
    path: undefined,
    branches: [],
    selectedBranchId: 0,
    appSetting: undefined,
    strictCashdesk: false,
};

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setPath: (state, action) => {
            state.path = action.payload;
        },
        setBranchInfo: (state, action) => {
            state.branches = action.payload.branches;
            state.selectedBranchId = action.payload.selected_branch_id;
        },
        setAppSetting: (state, action) => {
            state.appSetting = action.payload;
        },
        addBranch: (state, action) => {
            state.branches = [...state.branches, action.payload];
        },
        changeAppModule: (state) => {
            state.strictCashdesk = !state.strictCashdesk;
        },
        updateBranches: (state, action) => {
            const updatedBranch = action.payload;
            state.branches = [updatedBranch, ...state.branches.filter((b) => b.id !== updatedBranch.id)];
        },
        swapBranch: (state, action) => {
            state.selectedBranchId = action.payload;
        },
    },
});

export const { setPath, setAppSetting, setBranchInfo, updateBranches, addBranch, swapBranch, changeAppModule } = globalSlice.actions;
export default globalSlice.reducer;
